import React from "react";
import style from "./SideNav.css";
import { Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import AutoSizer from "react-virtualized-auto-sizer";
import { VariableSizeList as VirtualList } from "react-window";
import { findInfoPathFromBreadCrump, isAssetDefaultDashboard } from "../../../../config/utils";
import { stripQuery } from "../DashboardSwitcher";
import StarIcon from "../../../../assets/img/star.svg";
import StarActiveIcon from "../../../../assets/img/star-active.svg";
import { WithTooltip } from "../../../../utils/glossaryHelper/GlossaryWithTooltip";
import { rebuildGlossaryTooltip } from "../../../../utils/glossaryHelper/GlossaryTooltip";
import Loader from "../Loader";
import _ from "lodash";
class SideNav extends React.Component {
    _skipSearchCollapse = false;
    _searchDebounceTimer = null;
    virtualListRef = React.createRef();
    virtualRowHeights = {};
    virtualListKey = "";
    virtualListWidth = 0;
    virtualListResetFrame = null;
    state = {
        expandedNodes: [],
        subNode: [],
        childNode: [],
        buildingNode: [],
        flooorNode: [],
        lastNode: [],
        activeItem: "",
        activeSubNode1: "",
        activeSubNode2: "",
        activeSubNode3: "",
        activeSubNode4: "",
        activeSubNode5: "",
        activeStyle: [],
        activeTemp: "",
        subNodeCollapse: [],
        childNodeCollapse: [],
        buildingNodeCollapse: [],
        floorNodeCollapse: [],
        activeStyleTemp: [],
        parentNode: []
    };

    componentDidMount() {
        rebuildGlossaryTooltip();
        const restored = this.props.data?.length ? this.restoreActiveStateFromUrl() : null;
        // Bookmark focus only: the panel can be closed (and SideNav unmounted) when the bookmark is clicked, so the update-diff below never fires.
        if (this.props?.forceExpandPath?.length && this.props?.quickLinkFocus) {
            Promise.resolve(restored).then(() => {
                if (this._isUnmounted) return;
                this.applyForceExpandPath();
            });
        }
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    applyForceExpandPath = () => {
        const path = this.props?.forceExpandPath;
        const topItem = path?.[0];
        const lastItem = path?.length > 0 ? path?.[path?.length - 1] : null;
        if (!lastItem || !topItem) return;

        const isQuickLinkPath = Boolean(this.props?.quickLinkFocus);
        const isTopLevelEntry = isQuickLinkPath && path.length === 1;

        this.setState({
            // Skipped for a top-level entry: it resets expandedNodes, collapsing whatever group is open.
            ...(isTopLevelEntry
                ? {}
                : this.getSearchSelectionAccordionState({
                      item: topItem,
                      node: path?.[1],
                      nodeItem: path?.[2],
                      child: path?.[3],
                      building: path?.[4],
                      floor: path?.[5]
                  })),
            activeNode: isTopLevelEntry ? "" : lastItem.key,
            mainElement: topItem.key,
            activeItem: isTopLevelEntry ? topItem.url : ""
        });

        setTimeout(() => {
            const activeElement = document.querySelector(".activeStyle1");
            const target = isQuickLinkPath ? document.querySelector(".nav-click-active") || activeElement : activeElement;
            if (target) {
                target.scrollIntoView({ behavior: "smooth", block: isQuickLinkPath ? "nearest" : "start" });
            }
        }, 500);
    };

    componentDidUpdate(prevProps) {
        const { data } = this.props;
        const pathname = this.props.location.pathname.split("/")[1];
        const defaultHomePage = pathname.charAt(0).toUpperCase() + pathname.slice(1);
        let bcData = findInfoPathFromBreadCrump();
        if (prevProps?.location?.pathname !== this.props?.location?.pathname) {
            const firstBcKey = bcData?.[0]?.key;
            const firstBcPath = stripQuery(bcData?.[0]?.path);
            const currentPath = this.props.location.pathname.toLowerCase();
            const isFcaDashboard = firstBcKey === "dashboard" && firstBcPath !== "/assetdashboard";
            const isAssetDashboardHome = firstBcKey === "assetDashboard" && currentPath === "/assetdashboard";
            if (isFcaDashboard || isAssetDashboardHome) {
                this.setState({
                    activeItem: "",
                    activeNode: "",
                    mainElement: ""
                });
                return;
            }
        }
        if (prevProps?.sidebarSearchQuery !== this.props?.sidebarSearchQuery) {
            this.handleSearchExpand(Boolean(this.props.sidebarSearchQuery));
            return;
        }
        if (prevProps.data !== data) {
            // Auto-expand/collapse based on search api response
            if (this.isSidebarSearching() && this.props.sidebarSearchQuery === prevProps.sidebarSearchQuery) {
                const searchResponseChanged = !_.isEqual(prevProps.sidebarSearchResponse, this.props.sidebarSearchResponse);
                if (searchResponseChanged && !this._skipSearchCollapse) {
                    this.handleSearchExpand(true);
                }
                return;
            }
            if (this.props?.quickLinkFocus) {
                // A menu data reload here must not override the active bookmark focus.
            } else if ((!prevProps?.data || !prevProps?.data?.length) && data && data.length) {
                this.restoreActiveStateFromUrl();
                return;
            } else {
                pathname === data?.[0]?.label?.toLowerCase()?.trim()
                    ? this.setState({ activeItem: defaultHomePage })
                    : this.setState(() => {
                          const clean = url => (url ? "/" + url.replace(/^\//, "").toLowerCase() : "");

                          const targetPath = bcData?.[0]?.path;
                          let matchedUrl = "";

                          if (stripQuery(targetPath) === "/assetdashboard") {
                              return { activeItem: "" };
                          }

                          if (targetPath) {
                              const stack = [...(data || [])].map(item => ({ item, parentUrl: item.url }));

                              while (stack?.length) {
                                  const { item, parentUrl } = stack.pop();

                                  if (clean(item?.url) === clean(targetPath)) {
                                      matchedUrl = parentUrl;
                                      break;
                                  }

                                  if (item?.nodes?.length) {
                                      stack.push(...item.nodes.map(child => ({ item: child, parentUrl: item.url })));
                                  }
                              }
                          }
                          return { activeItem: matchedUrl || "" };
                      });
            }
        }
        if (prevProps.collapseAll !== this.props.collapseAll) {
            this.setState({
                activeItem: pathname.charAt(0).toUpperCase() + pathname.slice(1),
                activeStyle: "",
                activeSubNode1: "",
                activeSubNode2: "",
                activeSubNode3: "",
                activeSubNode4: "",
                activeSubNode5: "",
                subNode: [],
                childNode: [],
                flooorNode: [],
                buildingNode: [],
                expandedNodes: [],
                activeNode: "",
                childNodeCollapse: [],
                buildingNodeCollapse: [],
                floorNodeCollapse: [],
                subNodeCollapse: [],
                activeStyleTemp: [],
                parentNode: []
            });
        }
        if (this.props?.activeFlyoutPath?.length && this.props?.activeFlyoutPath !== prevProps?.activeFlyoutPath) {
            const path = this.props.activeFlyoutPath;
            const topItem = path?.[0];
            const lastItem = path?.length > 0 ? path[path.length - 1] : null;
            if (lastItem && topItem) {
                this.setState({
                    activeNode: lastItem.key,
                    mainElement: topItem.key,
                    activeItem: ""
                });
            }
        }
        if (this.props?.forceExpandPath?.length && this.props?.forceExpandPath !== prevProps?.forceExpandPath) {
            this.applyForceExpandPath();
        }
    }

    handleSearchExpand = () => {
        const query = this.props.sidebarSearchQuery?.toLowerCase();
        if (!query) {
            if (this._skipSearchCollapse) {
                this._skipSearchCollapse = false;
                this.props?.onSidebarSearchExpandComplete();
                return;
            }
            clearTimeout(this._searchDebounceTimer);
            this.setState(
                {
                    expandedNodes: [],
                    subNode: [],
                    childNode: [],
                    buildingNode: [],
                    flooorNode: [],
                    lastNode: [],
                    subNodeCollapse: [],
                    childNodeCollapse: [],
                    buildingNodeCollapse: [],
                    floorNodeCollapse: [],
                    activeStyle: [],
                    activeStyleTemp: [],
                    activeTemp: [],
                    activeUrl: ""
                },
                this.props.onSidebarSearchExpandComplete
            );
            return;
        }

        clearTimeout(this._searchDebounceTimer);
        this._searchDebounceTimer = setTimeout(() => {
            const data = this.props.data || [];

            let expandedNodes = [];
            let subNode = [];
            let childNode = [];
            let buildingNode = [];
            let flooorNode = [];
            let lastNode = [];
            let subNodeCollapse = [];
            let childNodeCollapse = [];
            let buildingNodeCollapse = [];
            let floorNodeCollapse = [];

            const labelMatches = label => label?.toLowerCase().includes(query);

            const walkFloors = (building, item) => {
                (building.nodes || [])?.forEach(floor => {
                    if (labelMatches(floor.label)) {
                        if (!flooorNode?.includes(building?.key + item?.label)) {
                            flooorNode.push(building?.key + item?.label);
                            floorNodeCollapse.push({ item: item?.url, key: building?.key + item?.label });
                        }
                    }
                });
            };

            const walkBuildings = (child, item, node, nodeItem) => {
                (child.nodes || [])?.forEach(building => {
                    const match = labelMatches(building?.label);
                    const childrenMatch = (building?.nodes || [])?.some(f => labelMatches(f?.label));
                    if (match || childrenMatch) {
                        if (!buildingNode.includes(child?.key + item?.label)) {
                            buildingNode.push(child?.key + item?.label);
                            buildingNodeCollapse.push({ item: item?.url, key: child?.key + item?.label });
                        }
                    }
                    if (childrenMatch) walkFloors(building, item);
                });
            };

            const walkChildren = (nodeItem, item, node) => {
                (nodeItem.nodes || [])?.forEach(child => {
                    const match = labelMatches(child?.label);
                    const descendantMatch = (child?.nodes || [])?.some(
                        b => labelMatches(b?.label) || (b?.nodes || [])?.some(f => labelMatches(f?.label))
                    );
                    if (match || descendantMatch) {
                        if (!childNode?.includes(nodeItem?.key + item?.label)) {
                            childNode.push(nodeItem?.key + item?.label);
                            childNodeCollapse.push({ item: item?.url, key: nodeItem?.key + item?.label });
                        }
                    }
                    if (descendantMatch) walkBuildings(child, item, node, nodeItem);
                });
            };

            const walkNodes = (node, item) => {
                (node.nodes || [])?.forEach(nodeItem => {
                    const match = labelMatches(nodeItem?.label);
                    const descendantMatch = (nodeItem?.nodes || [])?.some(
                        c =>
                            labelMatches(c?.label) ||
                            (c?.nodes || [])?.some(b => labelMatches(b?.label) || (b?.nodes || [])?.some(f => labelMatches(f?.label)))
                    );
                    if (match || descendantMatch) {
                        if (!subNode?.includes(node?.key + item?.label)) {
                            subNode.push(node?.key + item?.label);
                            subNodeCollapse.push({ item: item?.url, key: node?.key + item?.label });
                        }
                    }
                    if (descendantMatch) walkChildren(nodeItem, item, node);
                });
            };

            data.forEach(item => {
                if (item?.view !== true) return;
                const directChildMatch = (item?.nodes || [])?.some(n => labelMatches(n?.label));
                const deepMatch = (item?.nodes || []).some(
                    node =>
                        labelMatches(node?.label) ||
                        (node?.nodes || [])?.some(
                            ni =>
                                labelMatches(ni?.label) ||
                                (ni?.nodes || [])?.some(
                                    c =>
                                        labelMatches(c?.label) ||
                                        (c?.nodes || [])?.some(b => labelMatches(b?.label) || (b?.nodes || [])?.some(f => labelMatches(f.label)))
                                )
                        )
                );

                if (directChildMatch || deepMatch) {
                    if (!expandedNodes?.includes(item.key)) {
                        expandedNodes?.push(item?.key);
                    }
                    (item?.nodes || [])?.forEach(node => walkNodes(node, item));
                }
            });

            this.setState(
                {
                    expandedNodes,
                    subNode,
                    childNode,
                    buildingNode,
                    flooorNode,
                    lastNode,
                    subNodeCollapse,
                    childNodeCollapse,
                    buildingNodeCollapse,
                    floorNodeCollapse
                },
                () => this.props.onSidebarSearchExpandComplete?.(query)
            );
        }, 300);
    };

    getAccordionKey = (node, item, level) => {
        if (!node?.key) return "";
        return level >= 5 ? node.key : node.key + item?.label;
    };

    getCollapseEntries = entries => (Array.isArray(entries) ? entries : []);

    getSearchCollapseEntry = (key, item) => (key ? [{ item: item?.url, key }] : []);

    getNestedAccordionKeys = (node, item, level = 1, keys = { subNode: [], childNode: [], buildingNode: [], flooorNode: [], lastNode: [] }) => {
        if (!node) return keys;

        const accordionKey = this.getAccordionKey(node, item, level);

        switch (level) {
            case 1:
                keys.subNode.push(accordionKey);
                break;
            case 2:
                keys.childNode.push(accordionKey);
                break;
            case 3:
                keys.buildingNode.push(accordionKey);
                break;
            case 4:
                keys.flooorNode.push(accordionKey);
                break;
            default:
                keys.lastNode.push(accordionKey);
                break;
        }

        (node?.nodes || []).forEach(child => this.getNestedAccordionKeys(child, item, level + 1, keys));
        return keys;
    };

    resetNestedAccordionState = (node, item, level, extraState = {}) => {
        const keys = this.getNestedAccordionKeys(node, item, level);

        this.setState(prevState => ({
            ...extraState,
            subNode: prevState.subNode.filter(key => !keys.subNode.includes(key)),
            childNode: prevState.childNode.filter(key => !keys.childNode.includes(key)),
            buildingNode: prevState.buildingNode.filter(key => !keys.buildingNode.includes(key)),
            flooorNode: prevState.flooorNode.filter(key => !keys.flooorNode.includes(key)),
            lastNode: prevState.lastNode.filter(key => !keys.lastNode.includes(key)),
            subNodeCollapse: this.getCollapseEntries(prevState.subNodeCollapse).filter(entry => !keys.subNode.includes(entry.key)),
            childNodeCollapse: this.getCollapseEntries(prevState.childNodeCollapse).filter(entry => !keys.childNode.includes(entry.key)),
            buildingNodeCollapse: this.getCollapseEntries(prevState.buildingNodeCollapse).filter(entry => !keys.buildingNode.includes(entry.key)),
            floorNodeCollapse: this.getCollapseEntries(prevState.floorNodeCollapse).filter(entry => !keys.flooorNode.includes(entry.key))
        }));
    };

    getSingleAccordionOpenState = ({ item, node, nodeItem, child, building, floor } = {}) => {
        const label = item?.label || "";
        const subNodeKey = node?.key && label ? node.key + label : null;
        const childNodeKey = nodeItem?.key && label ? nodeItem.key + label : null;
        const buildingNodeKey = child?.key && label ? child.key + label : null;
        const floorNodeKey = building?.key && label ? building.key + label : null;

        return {
            expandedNodes: item?.key ? [item.key] : [],
            subNode: subNodeKey ? [subNodeKey] : [],
            childNode: childNodeKey ? [childNodeKey] : [],
            buildingNode: buildingNodeKey ? [buildingNodeKey] : [],
            flooorNode: floorNodeKey ? [floorNodeKey] : [],
            lastNode: floor?.key ? [floor.key] : [],
            subNodeCollapse: this.getSearchCollapseEntry(subNodeKey, item),
            childNodeCollapse: this.getSearchCollapseEntry(childNodeKey, item),
            buildingNodeCollapse: this.getSearchCollapseEntry(buildingNodeKey, item),
            floorNodeCollapse: this.getSearchCollapseEntry(floorNodeKey, item)
        };
    };

    getSearchSelectionAccordionState = ({ item, node, nodeItem, child, building, floor } = {}) => {
        const label = item?.label || "";
        const subNodeKey = (nodeItem || child || building || floor) && node?.key && label ? node.key + label : null;
        const childNodeKey = (child || building || floor) && nodeItem?.key && label ? nodeItem.key + label : null;
        const buildingNodeKey = (building || floor) && child?.key && label ? child.key + label : null;
        const floorNodeKey = floor && building?.key && label ? building.key + label : null;

        return {
            expandedNodes: item?.key ? [item.key] : [],
            subNode: subNodeKey ? [subNodeKey] : [],
            childNode: childNodeKey ? [childNodeKey] : [],
            buildingNode: buildingNodeKey ? [buildingNodeKey] : [],
            flooorNode: floorNodeKey ? [floorNodeKey] : [],
            lastNode: [],
            subNodeCollapse: this.getSearchCollapseEntry(subNodeKey, item),
            childNodeCollapse: this.getSearchCollapseEntry(childNodeKey, item),
            buildingNodeCollapse: this.getSearchCollapseEntry(buildingNodeKey, item),
            floorNodeCollapse: this.getSearchCollapseEntry(floorNodeKey, item)
        };
    };

    getClosedAccordionState = () => ({
        expandedNodes: [],
        subNode: [],
        childNode: [],
        buildingNode: [],
        flooorNode: [],
        lastNode: [],
        subNodeCollapse: [],
        childNodeCollapse: [],
        buildingNodeCollapse: [],
        floorNodeCollapse: []
    });

    restoreActiveStateFromUrl = async () => {
        const sideMenu = [
            { entity: "projects", params: {}, response: "getProjectMenuItemsResponse" },
            { entity: "efcis", params: {}, response: "getEfciMenuItemsResponse" }
        ];

        await Promise.all(sideMenu.map(item => this.props?.getSideMenuItems(item)));

        const { data } = this.props;
        if (!data || !data.length) return;

        const pathname = this.props.location.pathname.toLowerCase();
        const clean = url => (url ? "/" + url.replace(/^\//, "").toLowerCase() : "");

        const matchNode = (nodes, bcItem) => {
            return nodes.find(n => (n.url && clean(n.url) === pathname) || (bcItem && clean(n.url) === clean(bcItem.path)));
        };

        let bcData = findInfoPathFromBreadCrump() || [];

        const firstBc = bcData?.[0];

        // ===== TOP LEVEL =====
        let topItem =
            stripQuery(firstBc?.path) === "/assetdashboard"
                ? data.find(item => item?.key === "assetDashboard")
                : data.find(item => {
                      return clean(item.url) === pathname;
                  });

        if (firstBc && firstBc?.path !== "/home" && stripQuery(firstBc?.path) !== "/assetdashboard" && pathname !== "/dashboard") {
            topItem = data.find(item => {
                const bcMatch = stripQuery(item?.bc?.[0]?.path) === stripQuery(firstBc?.path);
                const childMatch = item?.nodes?.some(node => {
                    return clean(node?.url) === clean(firstBc?.path) ?? node?.bc?.[0]?.path === firstBc?.path;
                });

                return bcMatch || childMatch;
            });
        }

        if (!topItem) return;
        if (topItem?.url) {
            this.setState({ activeItem: topItem.url }, this.scrollToActive);
            return;
        }

        await new Promise(resolve =>
            this.setState(
                {
                    expandedNodes: [topItem?.key],
                    activeStyle: [topItem?.key],
                    activeStyleTemp: [
                        {
                            item: topItem?.key,
                            key: topItem?.key,
                            entity: topItem?.label,
                            parentNode: [topItem?.key]
                        }
                    ],
                    activeUrl: topItem?.key,
                    mainElement: topItem?.key,
                    activeItem: ""
                },
                resolve
            )
        );
        topItem = this?.props?.data?.find(d => d.key === topItem.key);
        let depth1Nodes = topItem?.nodes || [];

        let node1 = matchNode(
            depth1Nodes,
            bcData?.[1]?.path?.startsWith("/master-project-settings-template")
                ? {
                      ...(bcData?.[1] || {}),
                      path: "/master-project-settings-template"
                  }
                : bcData?.[1]
        );
        if (!node1) return;

        this.setState(
            {
                activeNode: node1?.key,
                mainElement: topItem?.key
            },
            () => {
                this.scrollToActive();
            }
        );
    };
    scrollToActive = () => {
        setTimeout(() => {
            const rows = this.getVirtualMenuRows(this.getScrollItems());
            const activeRowIndex = this.getActiveVirtualRowIndex(rows);
            if (activeRowIndex >= 0 && this.virtualListRef?.current) {
                this.virtualListRef.current.scrollToItem(activeRowIndex, "start");
            }
            const container = document.querySelector(".side-nav-menu-scroll");
            const el = document.querySelector(".activeStyle1") || document.querySelector(".nav-click-active");

            if (!el || !container) return;

            setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 0);
        }, 10);
    };

    setActiveStyle = async (label, mainItemKey, entity, parentKey) => {
        await this.setState({
            activeStyle: [...this.state.activeStyle, label],
            parentNode: [...this.state.parentNode, parentKey],
            activeStyleTemp: [
                ...this.state.activeStyleTemp,
                {
                    item: mainItemKey,
                    key: label,
                    entity: entity,
                    parentNode: [...this.state.parentNode, parentKey]
                }
            ],
            activeUrl: mainItemKey
        });
        // let activeData = this.state.activeStyleTemp;
        // let result = activeData.filter(i => i.item === mainItemKey).filter(u => u.parentNode.map(o => o === label));
        // debugger;
    };

    clearAllActiveItems = async (key, item) => {
        // let data = this.state.subNode;
        let data = this.state.subNodeCollapse;

        let activeData = this.state.activeStyleTemp;
        let subNode = [];
        // item && item.nodes && item.nodes.map(i => (this.state.subNode.includes(i.key) ? (subNode = data.filter(itm => itm.key !== i.key).filter(u => u.item.toLowerCase() !== key.toLowerCase())) : ""));

        // item && item.nodes && item.nodes.map(i => (this.state.subNode.includes(i.key) ? (subNode = data.filter(itm => itm !== i.key)) : ""));
        // subNode = await this.state.subNodeCollapse.filter(i => i.item !== item.key.charAt(0).toUpperCase() + item.key.slice(1));
        subNode = await this.getCollapseEntries(this.state?.subNodeCollapse || [])?.filter(
            i => i.item && i.item.toLowerCase() !== item.key.toLowerCase()
        );

        let childNode = await this.getCollapseEntries(this.state.childNodeCollapse).filter(
            i => i.item && i.item.toLowerCase() !== item.key.toLowerCase()
        );

        // let childNode = await this.state.childNodeCollapse.filter(i => i.item !== item.key.charAt(0).toUpperCase() + item.key.slice(1));
        let buildingNode = await this.getCollapseEntries(this.state.buildingNodeCollapse).filter(
            i => i.item && i.item.toLowerCase() !== item.key.toLowerCase()
        );
        let floorNode = await this.getCollapseEntries(this.state.floorNodeCollapse).filter(
            i => i.item && i.item.toLowerCase() !== item.key.toLowerCase()
        );
        let tempData = await activeData.filter(i => i.item && i.item.toLowerCase() !== item.key.toLowerCase());
        this.setState({
            ...this.state,
            expandedNodes: this.state.expandedNodes.filter(itm => itm !== key),
            ...(!this.props.sidebarSearchQuery
                ? {
                      subNode: subNode.map(i => i.key),
                      childNode: childNode.map(i => i.key),
                      buildingNode: buildingNode.map(i => i.key),
                      flooorNode: floorNode.map(i => i.key),
                      subNodeCollapse: subNode,
                      childNodeCollapse: childNode,
                      buildingNodeCollapse: buildingNode,
                      floorNodeCollapse: floorNode,
                      activeStyle: tempData.map(i => i.key),
                      activeStyleTemp: tempData,
                      activeTemp: tempData.map(i => i.key),
                      activeUrl: tempData.length ? tempData[tempData.length - 1].item : ""
                  }
                : {})
        });
    };

    removeItem = async (key, mainKey, entity, parentKey) => {
        // let c = [];
        // let filteredArray = [];
        // let filteredArray1 = [];

        // let activeData = this.state.activeStyleTemp;
        // let rest = activeData.filter(i => i.item !== mainKey);//other item
        // let result = activeData.filter(i => i.item === mainKey);//selectted item

        // result.map(u => u.parentNode.includes(key) ?
        //     filteredArray1 = [...filteredArray1, u]
        //     :
        //     c = [...c, u]
        // )
        // let resultKey = c.filter(i => i.key !== key);
        // filteredArray = filteredArray1.filter(i => i.key !== key);

        // let array = rest.concat(resultKey);
        // await this.setState({ activeStyleTemp: array });
        // await this.setState({ activeStyle: array.map(i => i.key) });
        // await this.setState({
        //     activeUrl: this.state.activeStyleTemp.length ? this.state.activeStyleTemp[this.state.activeStyleTemp.length - 1].item : ""
        // });
        // debugger;
        // filteredArray.map(i =>
        //     this.state.subNode.includes(i.key) ?

        //         this.setState({
        //             subNode: this.state.subNode.filter(u => u !== i.key)
        //         })
        //         :
        //         this.state.childNode.includes(i.key) ?
        //             this.setState({
        //                 childNode: this.state.childNode.filter(u => u !== i.key)
        //             })
        //             :
        //             this.state.buildingNode.includes(i.key) ?
        //                 this.setState({
        //                     buildingNode: this.state.buildingNode.filter(u => u !== i.key)
        //                 })
        //                 : this.state.flooorNode.includes(i.key) ?
        //                     this.setState({
        //                         flooorNode: this.state.flooorNode.filter(u => u !== i.key)
        //                     }) : ""
        // );

        // }

        let mainArray = [];
        let entityFilter = this.state.activeStyleTemp.filter(i => i.entity === entity && i.item === mainKey);
        let rest = this.state.activeStyleTemp.filter(i => i.entity !== entity).filter(u => u.item === mainKey);

        const arr = this.state.activeStyleTemp.filter(i => i.item === mainKey); // project
        let d = this.state.activeStyleTemp;
        const filtarr = arr.filter(i => i.key !== key);
        const pro = this.state.activeStyleTemp.filter(i => i.item !== mainKey); //other item
        mainArray = pro.concat(filtarr);

        // const startIndex = arr.findIndex(i => i.key === key);
        // const startIndex1 = d.findIndex(i => i.key === key);
        // let filteredArray = arr.splice(startIndex, arr.length - 1);
        // mainArray = pro.concat(arr);
        await this.setState({ activeStyleTemp: mainArray });
        await this.setState({ activeStyle: mainArray.map(i => i.key) });
        await this.setState({
            activeUrl: this.state.activeStyleTemp.length ? this.state.activeStyleTemp[this.state.activeStyleTemp.length - 1].item : ""
        });
    };

    // removeItem = async (key, mainKey, entity) => {
    //     let mainArray = [];
    //     let entityFilter = this.state.activeStyleTemp.filter(i => i.entity === entity && i.item === mainKey);
    //     let rest = this.state.activeStyleTemp.filter(i => i.entity !== entity).filter(u => u.item === mainKey);
    //     if (entityFilter.length > 1) {
    //         let result = entityFilter.filter(i => i.key !== key);
    //         const pro = this.state.activeStyleTemp.filter(i => i.item !== mainKey);//other item
    //         mainArray = rest.concat(result);
    //         await this.setState({ activeStyleTemp: mainArray });
    //         await this.setState({ activeStyle: mainArray.map(i => i.key) });
    //         await this.setState({
    //             activeUrl: this.state.activeStyleTemp.length ?
    //                 this.state.activeStyleTemp[this.state.activeStyleTemp.length - 1].item
    //                 : "",
    //         });
    //     }
    //     else {
    //         const arr = this.state.activeStyleTemp.filter(i => i.item === mainKey);// project
    //         let d = this.state.activeStyleTemp;
    //         const filtarr = arr.filter(i => i.key !== key);
    //         const pro = this.state.activeStyleTemp.filter(i => i.item !== mainKey);//other item
    //         mainArray = pro.concat(filtarr);

    //         const startIndex = arr.findIndex(i => i.key === key);
    //         const startIndex1 = d.findIndex(i => i.key === key);

    //         let filteredArray = arr.splice(startIndex, arr.length - 1);
    //         mainArray = pro.concat(arr);
    //         // await this.setState({ activeStyleTemp: mainArray });
    //         // await this.setState({ activeStyle: mainArray.map(i => i.key) });
    //         await this.setState({ activeStyleTemp: mainArray });
    //         await this.setState({ activeStyle: mainArray.map(i => i.key) });
    //         await this.setState({
    //             activeUrl: this.state.activeStyleTemp.length ?
    //                 this.state.activeStyleTemp[this.state.activeStyleTemp.length - 1].item
    //                 : "",
    //             // childNode: "",
    //             // buildingNode: "",
    //             // flooorNode: "",
    //         })

    //         filteredArray.map(i =>
    //             this.state.subNode.includes(i.key) ?

    //                 this.setState({
    //                     subNode: this.state.subNode.filter(u => u !== i.key)
    //                 })
    //                 :
    //                 this.state.childNode.includes(i.key) ?
    //                     this.setState({
    //                         childNode: this.state.childNode.filter(u => u !== i.key)
    //                     })
    //                     :
    //                     this.state.buildingNode.includes(i.key) ?
    //                         this.setState({
    //                             buildingNode: this.state.buildingNode.filter(u => u !== i.key)
    //                         })
    //                         : this.state.flooorNode.includes(i.key) ?
    //                             this.setState({
    //                                 flooorNode: this.state.flooorNode.filter(u => u !== i.key)
    //                             }) : ""
    //         );

    //     }

    // }

    setActiveNode(key, mainItemKey, item) {
        this.setState({
            activeNode: key,
            mainElement: mainItemKey,
            activeItem: item.url
        });
    }

    findEntityNameForChild = entity => {
        // eslint-disable-next-line default-case
        switch (entity) {
            case "projects":
                return "project_regions";
            case "regions":
                return "region_sites";
            case "sites":
                return "site_buildings";
            case "reports":
                return "report_regions";
            case "efcis":
                return "efci_regions";
            case "buildings":
                return "building_floors";
        }
    };

    findEntityNameForGrandChild = entity => {
        // eslint-disable-next-line default-case
        switch (entity) {
            case "projects":
                return "project_sites";
            case "reports":
                return "report_sites";
            case "efcis":
                return "efci_sites";
            case "regions":
                return "region_buildings";
            case "sites":
                return "site_floors";
        }
    };

    findEntityNameForGGrandChild = entity => {
        // eslint-disable-next-line default-case
        switch (entity) {
            case "projects":
                return "project_buildings";
            case "reports":
                return "report_buildings";
            case "efcis":
                return "efci_buildings";
            case "regions":
                return "region_floors";
        }
    };

    findEntityNameForFloors = entity => {
        switch (entity) {
            case "projects":
                return "project_floors";
        }
    };

    subMenuCheck = item => {
        if (item && item.view === false) {
            return true;
        } else if (item && item.view === true) {
            return false;
        }
        return item.view;
    };
    hasActiveDescendant = (nodes = []) => {
        for (const node of nodes) {
            if (node?.key === this.state?.activeNode) return true;
            if (node?.nodes?.length > 0 && this.hasActiveDescendant(node?.nodes)) return true;
        }
        return false;
    };

    isSidebarSearching = () => Boolean(this.props.sidebarSearchQuery);

    handleSearchResultSelection = async ({ item, node, nodeItem, child, building, floor } = {}, isParentItem = false) => {
        if (!this.isSidebarSearching()) return;

        const label = item?.label || "";

        const newExpandedNodes = item?.key ? [item.key] : [];
        const newSubNode = (nodeItem || child || building || floor) && node?.key && label ? [node.key + label] : [];
        const newChildNode = (child || building || floor) && nodeItem?.key && label ? [nodeItem.key + label] : [];
        const newBuildingNode = (building || floor) && child?.key && label ? [child.key + label] : [];
        const newFlooorNode = floor?.key && building?.key && label ? [building.key + label] : [];
        const activeNodeKey = floor?.key || building?.key || child?.key || nodeItem?.key || node?.key || null;

        this._skipSearchCollapse = true;
        await this.props?.onSidebarSearchResultSelect?.({ item, node, nodeItem, child, building, floor });

        if (isParentItem) {
            this.setState(
                {
                    ...this.getClosedAccordionState(),
                    activeNode: "",
                    mainElement: item?.key
                },
                () => {
                    this.props?.onSidebarSearchClear();
                    this.scrollToActive(item?.key);
                }
            );
            return;
        }

        this.setState(
            {
                expandedNodes: newExpandedNodes,
                subNode: newSubNode,
                childNode: newChildNode,
                buildingNode: newBuildingNode,
                flooorNode: newFlooorNode,
                lastNode: [],
                subNodeCollapse: this.getSearchCollapseEntry(newSubNode[0], item),
                childNodeCollapse: this.getSearchCollapseEntry(newChildNode[0], item),
                buildingNodeCollapse: this.getSearchCollapseEntry(newBuildingNode[0], item),
                floorNodeCollapse: this.getSearchCollapseEntry(newFlooorNode[0], item),
                activeNode: activeNodeKey,
                mainElement: item?.key,
                activeItem: ""
            },
            () => {
                this.props?.onSidebarSearchClear();
                this.scrollToActive();
            }
        );
    };
    highlightMatch = label => {
        const query = this.props.sidebarSearchQuery;
        if (!query || !label) return label;

        const index = label.toLowerCase().indexOf(query.toLowerCase());
        if (index === -1) return label;

        return (
            <span className="side-nav-search-text">
                {label.slice(0, index)}
                <span className="side-nav-text-highlight">{label.slice(index, index + query.length)}</span>
                {label.slice(index + query.length)}
            </span>
        );
    };

    getScrollItems = () => (this.props.data || []).filter(d => d.view === true);

    getVirtualMenuRows = (items = []) => {
        const rows = [];
        items.forEach((item, itemIndex) => {
            rows.push({ type: "item", item, itemIndex });
            if (!this.state.expandedNodes.includes(item.key)) return;

            (item.nodes || []).forEach((node, nodeIndex) => {
                if (this.subMenuCheck(node)) return;
                rows.push({ type: "node", item, node, nodeIndex });
                if (!this.state.subNode.includes(node.key + item.label)) return;

                if (node.nodes && node.nodes.length > 0) {
                    node.nodes.forEach(nodeItem => {
                        rows.push({ type: "nodeItem", item, node, nodeItem });
                        if (!this.state.childNode.includes(nodeItem.key + item.label)) return;

                        if (nodeItem.nodes && nodeItem.nodes.length > 0) {
                            nodeItem.nodes.forEach(child => {
                                rows.push({ type: "child", item, node, nodeItem, child });
                                if (!this.state.buildingNode.includes(child.key + item.label)) return;

                                if (child.nodes && child.nodes.length > 0) {
                                    child.nodes.forEach(building => {
                                        rows.push({ type: "building", item, node, nodeItem, child, building });
                                        if (!this.state.flooorNode.includes(building.key + item.label)) return;

                                        if (building.nodes && building.nodes.length > 0) {
                                            building.nodes.forEach(floor =>
                                                rows.push({ type: "floor", item, node, nodeItem, child, building, floor })
                                            );
                                        } else {
                                            rows.push({ type: "empty", className: "childmain4", spacerClass: "childspan2" });
                                        }
                                    });
                                } else {
                                    rows.push({ type: "empty", className: "childmain3", spacerClass: "childspan1" });
                                }
                            });
                        } else {
                            rows.push({ type: "empty", className: "childmain2", spacerClass: "childspan" });
                        }
                    });
                } else {
                    rows.push({ type: "empty", className: "childmain1", spacerClass: "child1" });
                }
            });
        });
        return rows;
    };

    getVirtualRowDefaultSize = row => {
        return row?.type === "item" ? 64 : 40;
    };

    getVirtualRowCacheKey = (row, index) =>
        [
            row?.type || "row",
            row?.item?.key,
            row?.item?.label,
            row?.node?.key,
            row?.node?.label,
            row?.nodeItem?.key,
            row?.nodeItem?.label,
            row?.child?.key,
            row?.child?.label,
            row?.building?.key,
            row?.building?.label,
            row?.floor?.key,
            row?.floor?.label,
            row?.className,
            index
        ]
            .filter(value => value !== undefined && value !== null)
            .join("|");

    getVirtualRowSize = index => {
        const row = this.virtualRows?.[index];
        return this.virtualRowHeights[this.getVirtualRowCacheKey(row, index)] || this.getVirtualRowDefaultSize(row);
    };

    measureVirtualRow = (index, node) => {
        if (!node) return;

        const measure = () => {
            const row = this.virtualRows?.[index];
            if (!row) return;

            const measuredHeight = Math.ceil(node?.getBoundingClientRect()?.height);
            const nextHeight = Math.max(measuredHeight, this.getVirtualRowDefaultSize(row));
            const cacheKey = this.getVirtualRowCacheKey(row, index);

            if (nextHeight > 0 && this?.virtualRowHeights?.[cacheKey] !== nextHeight) {
                this.virtualRowHeights[cacheKey] = nextHeight;
                this.virtualListRef.current?.resetAfterIndex(index);
            }
        };

        if (typeof window !== "undefined" && window?.requestAnimationFrame) {
            window.requestAnimationFrame(measure);
        } else {
            measure();
        }
    };

    scheduleVirtualListReset = () => {
        const reset = () => {
            this.virtualListResetFrame = null;
            this.virtualListRef.current?.resetAfterIndex(0);
        };

        if (typeof window !== "undefined" && window.requestAnimationFrame) {
            if (this.virtualListResetFrame) {
                window.cancelAnimationFrame?.(this.virtualListResetFrame);
            }
            this.virtualListResetFrame = window.requestAnimationFrame(reset);
        } else {
            reset();
        }
    };

    getActiveVirtualRowIndex = rows =>
        rows.findIndex(row => {
            if (row.type === "item") {
                const clean = url => (url ? "/" + url.replace(/^\//, "").toLowerCase() : "");
                return row.item?.url && clean(row.item.url) === clean(this.state.activeItem) && !this.state.activeNode;
            }
            return row.item?.key === this.state.mainElement && this.state.activeNode && this.getVirtualRowNode(row)?.key === this.state.activeNode;
        });

    getVirtualRowNode = row => row.floor || row.building || row.child || row.nodeItem || row.node;

    renderEmptyVirtualRow = row => (
        <div className={row.className}>
            <span className={row.spacerClass}></span>
            <span className="title-tip title-tip-up sideMnu childName cursor-diabled">No Data</span>
        </div>
    );

    renderVirtualNestedRow = row => {
        const { item, node, nodeItem, child, building, floor } = row;
        const nodeData = this.getVirtualRowNode(row);
        const config = {
            node: {
                level: 1,
                rowClass: "childmain",
                spacerClass: "child",
                activeSubNode: "activeSubNode1",
                openState: "subNode",
                openKey: node?.key + item?.label,
                activeParentKey: item?.key,
                sideMenuName: this.findEntityNameForChild(item?.name),
                sideMenuArgs: [node, node?.key],
                collapseState: "subNodeCollapse",
                collapseItem: item?.url,
                removeParentKey: item?.key,
                setActiveParentKey: item?.key,
                clickLevel: 1,
                clickParent: null,
                searchSelection: { item, node }
            },
            nodeItem: {
                level: 2,
                rowClass: "childmain1",
                spacerClass: "child1",
                activeSubNode: "activeSubNode2",
                openState: "childNode",
                openKey: nodeItem?.key + item?.label,
                activeParentKey: node?.key,
                sideMenuName: this.findEntityNameForGrandChild(item?.name),
                sideMenuArgs: [nodeItem, node?.key, nodeItem?.key],
                collapseState: "childNodeCollapse",
                collapseItem: item?.url,
                removeParentKey: node?.key,
                setActiveParentKey: node?.key,
                clickLevel: 2,
                clickParent: node,
                searchSelection: { item, node, nodeItem }
            },
            child: {
                level: 3,
                rowClass: "childmain2",
                spacerClass: "childspan",
                activeSubNode: "activeSubNode3",
                openState: "buildingNode",
                openKey: child?.key + item?.label,
                activeParentKey: nodeItem?.key,
                sideMenuName: this.findEntityNameForGGrandChild(item?.name),
                sideMenuArgs: [child, node?.key, nodeItem?.key, child?.key],
                collapseState: "buildingNodeCollapse",
                collapseItem: item?.url,
                removeParentKey: nodeItem?.key,
                setActiveParentKey: nodeItem?.key,
                clickLevel: 3,
                clickParent: node,
                searchSelection: { item, node, nodeItem, child }
            },
            building: {
                level: 4,
                rowClass: "childmain3",
                spacerClass: "childspan1",
                activeSubNode: "activeSubNode4",
                openState: "flooorNode",
                openKey: building?.key + item?.label,
                activeParentKey: child?.key,
                sideMenuName: this.findEntityNameForFloors(item?.name),
                sideMenuArgs: [building, node?.key, nodeItem?.key, child?.key, building?.key],
                collapseState: "floorNodeCollapse",
                collapseItem: item?.url,
                removeParentKey: child?.key,
                setActiveParentKey: child?.key,
                clickLevel: 4,
                clickParent: node,
                searchSelection: { item, node, nodeItem, child, building }
            },
            floor: {
                level: 5,
                rowClass: "childmain4",
                spacerClass: "childspan2",
                activeSubNode: "activeSubNode5",
                openState: "lastNode",
                openKey: floor?.key,
                activeParentKey: building?.key,
                clickLevel: 5,
                clickParent: node,
                searchSelection: { item, node, nodeItem, child, building, floor }
            }
        }[row.type];

        if (!config || !nodeData) return null;

        const { quickLinks } = this.props;
        let checkUrl = nodeData?.baseUrl || nodeData?.url || "";
        checkUrl = "/" + checkUrl?.toLowerCase();
        nodeData.linkId = quickLinks?.data?.find(link => link.url?.toLowerCase() === checkUrl)?.id;

        const hasChildren = row.type === "floor" ? floor?.nodes && floor.nodes.length > 0 : nodeData?.has_child;
        const isOpen = this.state[config.openState]?.includes(config.openKey);
        const rowClass = `${this.state.activeNode === nodeData.key && this.state.mainElement === item.key ? "activeStyle1" : ""} ${
            this.state.activeStyle[this.state.activeStyle.length - 1] === config.activeParentKey && this.state.activeUrl === item.key
                ? `${config.rowClass} activeStyle`
                : config.rowClass
        }`;

        const toggleNode = async () => {
            if (!hasChildren) return;
            if (row.type === "floor") {
                this.setState({
                    lastNode: isOpen ? this.state?.lastNode.filter(itm => itm !== floor.key) : [...this.state?.lastNode, floor?.key],
                    floorNodeCollapse: isOpen ? this.state.floorNodeCollapse : [...this.state.floorNodeCollapse, { item: item.url, key: floor.key }]
                });
                return;
            }

            const flag = this.state.activeStyleTemp.some(i => i.key === nodeData.key && i.item.toLowerCase() === item.key.toLowerCase());
            if (isOpen) {
                this.resetNestedAccordionState(nodeData, item, config.level);
            } else {
                this.props.sideMenuHandler(config.sideMenuName, ...config.sideMenuArgs);
                this.setState({
                    [config.openState]: [...this.state[config.openState], config.openKey],
                    [config.collapseState]: [...this.state[config.collapseState], { item: config.collapseItem, key: config.openKey }]
                });
            }

            if (flag) {
                this.removeItem(nodeData.key, item.key, nodeData.entity, config.removeParentKey);
            } else {
                await this.setActiveStyle(nodeData.key, item.key, nodeData.entity, config.setActiveParentKey);
            }
        };

        const onLabelClick =
            nodeData.url || row.type === "building" || row.type === "floor"
                ? async () => {
                      await this.props.onClickItem(
                          nodeData,
                          config.clickLevel,
                          () => {
                              this.setState({
                                  activeSubNode1: config.activeSubNode === "activeSubNode1" ? nodeData.key : "",
                                  activeSubNode2: config.activeSubNode === "activeSubNode2" ? nodeData.key : "",
                                  activeSubNode3: config.activeSubNode === "activeSubNode3" ? nodeData.key : "",
                                  activeSubNode4: config.activeSubNode === "activeSubNode4" ? nodeData.key : "",
                                  activeSubNode5: config.activeSubNode === "activeSubNode5" ? nodeData.key : ""
                              });
                              this.setActiveNode(nodeData.key, item.key, item);
                          },
                          config.clickParent
                      );
                      this.handleSearchResultSelection(config.searchSelection);
                  }
                : null;

        return (
            <div className="subMain">
                <div className={rowClass}>
                    <span className={config.spacerClass}></span>
                    <span>
                        {!hasChildren ? (
                            <Icon name="circle" color={this.state[config.activeSubNode] === nodeData.key ? "blue" : "grey"} size="mini" />
                        ) : (
                            <Icon name={isOpen ? "minus square" : "plus square"} color="grey" onClick={toggleNode} />
                        )}
                    </span>
                    <span
                        className={
                            nodeData.url || row.type === "building" || row.type === "floor"
                                ? "title-tip title-tip-up sideMnu childName"
                                : "title-tip title-tip-up sideMnu childName cursor-diabled"
                        }
                        onMouseEnter={this.props.onItemLeave}
                        onMouseLeave={this.props.onItemLeave}
                        onClick={onLabelClick}
                        title={nodeData.entity}
                        data-multiline={true}
                        data-place="top"
                        data-effect="solid"
                        data-background-color="#007bff"
                        delay-update="1000"
                    >
                        {this.highlightMatch(nodeData.label)}
                    </span>
                    {row.type === "node" && nodeData.isQuickLink && (
                        <i
                            className="favourite-menu-icon"
                            data-tip={nodeData.linkId ? "Remove this Menu From Dashboard Bookmarks" : "Add this Menu to Dashboard Bookmarks"}
                            data-for="favoriteQuickLinkMenuSub"
                            onClick={e => {
                                e.stopPropagation();
                                this.props.toggleFavoriteMenu(nodeData);
                            }}
                        >
                            <img src={nodeData.linkId ? StarActiveIcon : StarIcon} alt="" />
                        </i>
                    )}
                </div>
            </div>
        );
    };

    renderVirtualMenuRow = ({ index, style, data }) => {
        const row = data[index];
        if (!row) return null;
        const content =
            row.type === "item"
                ? this.renderNavDataItem(row?.item, row?.itemIndex, false)
                : row.type === "empty"
                  ? this.renderEmptyVirtualRow(row)
                  : this.renderVirtualNestedRow(row);

        return (
            <div style={style} className="virtual-search-row-container">
                <div ref={node => this.measureVirtualRow(index, node)}>{content}</div>
            </div>
        );
    };

    renderNavDataItem = (item, i, renderChildren = true) => {
        const { quickLinks } = this.props;
        let checkUrl = item.baseUrl || item.url || "";
        checkUrl = "/" + checkUrl?.toLowerCase();
        item.linkId = quickLinks?.data?.find(link => link.url?.toLowerCase() === checkUrl)?.id;
        const clean = url => (url ? "/" + url.replace(/^\//, "").toLowerCase() : "");
        const firstBc = findInfoPathFromBreadCrump()?.[0];
        return item.view === true ? (
            <React.Fragment key={i}>
                <div className={`main ${item?.key === "mobile-solutions" ? "mobile-solution-menu" : ""}`}>
                    <div
                        className={`${
                            (item.url &&
                                typeof item.url === "string" &&
                                clean(item.url.toLowerCase()) === clean(this.state.activeItem?.toLowerCase()) &&
                                !this.state.activeNode) ||
                            (this.hasActiveDescendant(item?.nodes) && this.state.mainElement === item?.key)
                                ? "navTitle active nav-click-active"
                                : "navTitle"
                        }`}
                        onMouseEnter={e => {
                            if (item.nodes && item.nodes.length > 0) {
                                this.props.onItemHover(e, item);
                            } else {
                                this.props.onItemLeave();
                            }
                        }}
                        onMouseLeave={this.props.onItemLeave}
                    >
                        <span className="d-flex menu-wrapper">
                            {item.icon && (
                                <span className={`menu-icon ${item?.key === "dashboard" || item?.key === "assetDashboard" ? "dash-side-icon" : ""}`}>
                                    {item?.key === "dashboard" || item?.key === "assetDashboard" ? (
                                        (item?.key === "assetDashboard") === isAssetDefaultDashboard() ? (
                                            <i className="fa fa-home home-icon-badge"></i>
                                        ) : item?.key === "assetDashboard" ? (
                                            <img src={item.icon} alt="" />
                                        ) : (
                                            <i className="fas fa-clipboard-list home-icon-badge"></i>
                                        )
                                    ) : (
                                        <img src={item.icon} alt="" />
                                    )}
                                </span>
                            )}
                            <span
                                className="name"
                                onClick={async () => {
                                    if (item.url) {
                                        const proceed = await this.props.onClickItem(item, 0, () => {
                                            this.setState({ activeItem: item.url, activeNode: "" });
                                        });
                                        this.handleSearchResultSelection({ item }, true);
                                    } else {
                                        if (this.state.expandedNodes.includes(item.key)) {
                                            this.clearAllActiveItems(item.key, item);
                                            this.removeItem(item.key, item.key);
                                        } else {
                                            this.props.sideMenuHandler(item.name, item);
                                            this.setState({
                                                ...this.state,
                                                expandedNodes: [...this.state.expandedNodes, item.key]
                                            });
                                            this.setActiveStyle(item.key, item.key, item.label, item.key);
                                        }
                                    }
                                }}
                            >
                                <strong>
                                    {this.isSidebarSearching() ? (
                                        this.highlightMatch(item.label)
                                    ) : (
                                        <WithTooltip id="favoriteQuickLinkMenu">{item.label}</WithTooltip>
                                    )}
                                </strong>
                            </span>
                            {item.isQuickLink && (
                                <span
                                    className={`favourite-icon-wrapper ${item.linkId ? "menu-fav-active" : ""}`}
                                    data-tip={item.linkId ? "Remove this Menu From Dashboard Bookmarks" : "Add this Menu to Dashboard Bookmarks"}
                                    data-for="favorite"
                                >
                                    <i
                                        className="favourite-menu-icon"
                                        onClick={e => {
                                            e.stopPropagation();
                                            this.props.toggleFavoriteMenu(item);
                                        }}
                                    >
                                        <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.19055 3.28223L6.37648 5.05058L6.80488 7.54816C6.82352 7.65737 6.77867 7.76775 6.68897 7.83298C6.6383 7.86997 6.57802 7.88861 6.51773 7.88861C6.47143 7.88861 6.42483 7.87754 6.38231 7.85512L4.13926 6.67593L1.8965 7.85483C1.79865 7.90666 1.67953 7.89822 1.58984 7.83269C1.50014 7.76746 1.45529 7.65708 1.47393 7.54787L1.90233 5.05028L0.0879652 3.28223C0.00875072 3.20476 -0.020081 3.08885 0.0142841 2.98372C0.0486492 2.87859 0.139804 2.80141 0.249598 2.78539L2.75679 2.42136L3.87803 0.149182C3.97617 -0.0497275 4.30235 -0.0497275 4.40049 0.149182L5.52173 2.42136L8.02892 2.78539C8.13871 2.80141 8.22987 2.87829 8.26423 2.98372C8.2986 3.08914 8.26977 3.20447 8.19055 3.28223Z" />
                                        </svg>
                                    </i>
                                </span>
                            )}
                            <ReactTooltip
                                id="favorite"
                                className="rc-tooltip-custom-class"
                                place="bottom"
                                delayShow={1000}
                                effect="solid"
                                backgroundColor="#007bff"
                            />
                            {item.nodes && (item?.isExpandable || item?.nodes?.length > 0) && item.key !== "projects" && item?.key !== "efci" && (
                                <span className="navIcon">
                                    <Icon
                                        className={`${this.state.expandedNodes.includes(item.key) ? "active" : ""}`}
                                        name={this.state.expandedNodes.includes(item.key) ? "chevron down" : "chevron right"}
                                        color="grey"
                                        onClick={async e => {
                                            e.stopPropagation();
                                            if (this.state.expandedNodes.includes(item.key)) {
                                                await this.clearAllActiveItems(item.key, item);
                                                await this.removeItem(item.key, item.key);
                                            } else {
                                                this.props.sideMenuHandler(item.name, item);
                                                await this.setState({
                                                    ...this.state,
                                                    expandedNodes: [...this.state.expandedNodes, item.key]
                                                });
                                                await this.setActiveStyle(item.key, item.key, item.label, item.key);
                                            }
                                        }}
                                    />
                                </span>
                            )}
                        </span>
                        {item.nodes && (item?.isExpandable || item?.nodes?.length > 0) && (item.key === "projects" || item?.key === "efci") && (
                            <span
                                className={`navIcon split-navIcon ${
                                    this.hasActiveDescendant(item?.nodes) && this.state.mainElement === item?.key ? "nav-click-active" : ""
                                }`}
                                onClick={async e => {
                                    e.stopPropagation();
                                    if (this.state.expandedNodes.includes(item.key)) {
                                        await this.clearAllActiveItems(item.key, item);
                                        await this.removeItem(item.key, item.key);
                                    } else {
                                        this.props.sideMenuHandler(item.name, item);
                                        await this.setState({
                                            ...this.state,
                                            expandedNodes: [...this.state.expandedNodes, item.key]
                                        });
                                        await this.setActiveStyle(item.key, item.key, item.label, item.key);
                                    }
                                }}
                            >
                                <Icon
                                    className={`${this.state.expandedNodes.includes(item.key) ? "active" : ""}`}
                                    name={this.state.expandedNodes.includes(item.key) ? "chevron down" : "chevron right"}
                                    color="grey"
                                />
                            </span>
                        )}
                    </div>
                    {item?.hasDivider && <div className="menu-divider mb-0"></div>}
                    {renderChildren && item && item.nodes && item.nodes.length > 0 ? (
                        <>
                            {item &&
                                item.nodes.map((node, i) => {
                                    let checkUrl = node.baseUrl || node.url || "";
                                    checkUrl = "/" + checkUrl?.toLowerCase();
                                    node.linkId = quickLinks?.data?.find(link => link.url?.toLowerCase() === checkUrl)?.id;
                                    return (
                                        !this.subMenuCheck(node) && (
                                            <React.Fragment key={i}>
                                                {this.state.expandedNodes.includes(item.key) ? (
                                                    <div className="subMain">
                                                        <div
                                                            className={`${
                                                                this.state.activeNode == node.key &&
                                                                this.state.mainElement === item.key &&
                                                                (!this.state.activeItem || this.state.activeItem === item?.url)
                                                                    ? "activeStyle1"
                                                                    : ""
                                                            }
                                                                        ${
                                                                            this.state.activeStyle[this.state.activeStyle.length - 1] == item.key &&
                                                                            this.state.activeUrl === item.key
                                                                                ? "childmain activeStyle"
                                                                                : "childmain"
                                                                        }`}
                                                        >
                                                            <span className="child"></span>
                                                            <span>
                                                                {
                                                                    // node && (  !node.nodes || !node.nodes.length)
                                                                    !node.has_child ? (
                                                                        <Icon
                                                                            name="circle"
                                                                            color={this.state.activeSubNode1 == node.key ? "blue" : "grey"}
                                                                            size="mini"
                                                                        />
                                                                    ) : (
                                                                        <Icon
                                                                            name={
                                                                                this.state.subNode.includes(node.key + item.label)
                                                                                    ? "minus square"
                                                                                    : "plus square"
                                                                            }
                                                                            color="grey"
                                                                            onClick={async () => {
                                                                                if (this.state.subNode.includes(node.key + item.label)) {
                                                                                    this.resetNestedAccordionState(node, item, 1);
                                                                                } else {
                                                                                    this.props.sideMenuHandler(
                                                                                        this.findEntityNameForChild(item.name),
                                                                                        node,
                                                                                        node.key
                                                                                    );
                                                                                    this.setState({
                                                                                        ...this.state,
                                                                                        subNode: [...this.state.subNode, node.key + item.label],
                                                                                        subNodeCollapse: [
                                                                                            ...this.state.subNodeCollapse,
                                                                                            {
                                                                                                item: item.url,
                                                                                                key: node.key + item.label
                                                                                            }
                                                                                        ]
                                                                                    });
                                                                                }

                                                                                const flag1 = this.state.activeStyleTemp.some(
                                                                                    i =>
                                                                                        i.key === node.key &&
                                                                                        i.item.toLowerCase() === item.key.toLowerCase()
                                                                                );
                                                                                if (flag1) {
                                                                                    this.removeItem(node.key, item.key, node.entity, item.key);
                                                                                } else {
                                                                                    await this.setActiveStyle(
                                                                                        node.key,
                                                                                        item.key,
                                                                                        node.entity,
                                                                                        item.key
                                                                                    );
                                                                                }
                                                                            }}
                                                                        />
                                                                    )
                                                                }
                                                            </span>
                                                            <span
                                                                className={
                                                                    node.url
                                                                        ? "title-tip title-tip-up sideMnu childName"
                                                                        : "title-tip title-tip-up sideMnu childName cursor-diabled"
                                                                }
                                                                onMouseEnter={e => {
                                                                    this.props.onItemLeave();
                                                                }}
                                                                onMouseLeave={this.props.onItemLeave}
                                                                onClick={
                                                                    node.url
                                                                        ? async e => {
                                                                              this.props.onClickItem(node, 1, () => {
                                                                                  this.setState({
                                                                                      activeSubNode1: node.key
                                                                                  });
                                                                                  this.setState({
                                                                                      activeSubNode2: ""
                                                                                  });
                                                                                  this.setState({
                                                                                      activeSubNode3: "",
                                                                                      activeSubNode4: "",
                                                                                      activeSubNode5: ""
                                                                                  });
                                                                                  this.setActiveNode(node.key, item.key, item);
                                                                              });
                                                                              this.handleSearchResultSelection({ item, node });
                                                                          }
                                                                        : null
                                                                }
                                                                data-tip={node.entity}
                                                                data-multiline={true}
                                                                data-place="top"
                                                                data-effect="solid"
                                                                data-background-color="#007bff"
                                                                delay-update="1000"
                                                            >
                                                                {/* {node && node.entity ? <ReactTooltip /> : null} */}
                                                                {this.highlightMatch(node.label)}
                                                            </span>
                                                            {node.isQuickLink && (
                                                                <i
                                                                    className="favourite-menu-icon"
                                                                    data-tip={
                                                                        item.linkId
                                                                            ? "Remove this Menu From Dashboard Bookmarks"
                                                                            : "Add this Menu to Dashboard Bookmarks"
                                                                    }
                                                                    data-for="favoriteQuickLinkMenuSub"
                                                                    onClick={e => {
                                                                        e.stopPropagation();
                                                                        this.props.toggleFavoriteMenu(node);
                                                                    }}
                                                                >
                                                                    <img src={node.linkId ? StarActiveIcon : StarIcon} alt="" />
                                                                </i>
                                                            )}
                                                            <ReactTooltip
                                                                id="favoriteQuickLinkMenuSub"
                                                                className="rc-tooltip-custom-class"
                                                                place="bottom"
                                                                delayShow={1000}
                                                                effect="solid"
                                                                backgroundColor="#007bff"
                                                            />
                                                        </div>

                                                        {/* till here check */}

                                                        {this.state.subNode.includes(node.key + item.label) ? (
                                                            <>
                                                                {(node &&
                                                                    node.nodes &&
                                                                    node.nodes.length > 0 &&
                                                                    node.nodes.map(nodeItem => {
                                                                        return (
                                                                            <>
                                                                                <div
                                                                                    className={`${
                                                                                        this.state.activeNode == nodeItem.key &&
                                                                                        this.state.mainElement === item.key
                                                                                            ? "activeStyle1"
                                                                                            : ""
                                                                                    }
                                                                                                ${
                                                                                                    this.state.activeStyle[
                                                                                                        this.state.activeStyle.length - 1
                                                                                                    ] == node.key && this.state.activeUrl === item.key
                                                                                                        ? "childmain1 activeStyle"
                                                                                                        : "childmain1"
                                                                                                }`}
                                                                                >
                                                                                    <span className="child1"></span>
                                                                                    <span>
                                                                                        {
                                                                                            // nodeItem &&
                                                                                            // (!nodeItem.nodes ||
                                                                                            //     !nodeItem.nodes.length)
                                                                                            !nodeItem.has_child ? (
                                                                                                <Icon
                                                                                                    name="circle"
                                                                                                    color={
                                                                                                        this.state.activeSubNode2 == nodeItem.key
                                                                                                            ? "blue"
                                                                                                            : "grey"
                                                                                                    }
                                                                                                    size="mini"
                                                                                                />
                                                                                            ) : (
                                                                                                <Icon
                                                                                                    name={
                                                                                                        this.state.childNode.includes(
                                                                                                            nodeItem.key + item.label
                                                                                                        )
                                                                                                            ? "minus square"
                                                                                                            : "plus square"
                                                                                                    }
                                                                                                    color="grey"
                                                                                                    onClick={async () => {
                                                                                                        const flag = this.state.activeStyleTemp.some(
                                                                                                            i =>
                                                                                                                i.key === nodeItem.key &&
                                                                                                                i.item.toLowerCase() ===
                                                                                                                    item.key.toLowerCase()
                                                                                                        );
                                                                                                        if (
                                                                                                            this.state.childNode.includes(
                                                                                                                nodeItem.key + item.label
                                                                                                            )
                                                                                                        ) {
                                                                                                            this.resetNestedAccordionState(
                                                                                                                nodeItem,
                                                                                                                item,
                                                                                                                2
                                                                                                            );
                                                                                                        } else {
                                                                                                            this.props.sideMenuHandler(
                                                                                                                this.findEntityNameForGrandChild(
                                                                                                                    item.name
                                                                                                                ),
                                                                                                                nodeItem,
                                                                                                                node.key,
                                                                                                                nodeItem.key
                                                                                                            );
                                                                                                            this.setState({
                                                                                                                ...this.state,
                                                                                                                childNode: [
                                                                                                                    ...this.state.childNode,
                                                                                                                    nodeItem.key + item.label
                                                                                                                ],

                                                                                                                childNodeCollapse: [
                                                                                                                    ...this.state.childNodeCollapse,
                                                                                                                    {
                                                                                                                        item: item.url,
                                                                                                                        key: nodeItem.key + item.label
                                                                                                                    }
                                                                                                                ]
                                                                                                            });
                                                                                                        }
                                                                                                        if (flag) {
                                                                                                            this.removeItem(
                                                                                                                nodeItem.key,
                                                                                                                item.key,
                                                                                                                nodeItem.entity,
                                                                                                                node.key
                                                                                                            );
                                                                                                        } else {
                                                                                                            await this.setActiveStyle(
                                                                                                                nodeItem.key,
                                                                                                                item.key,
                                                                                                                nodeItem.entity,
                                                                                                                node.key
                                                                                                            );
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            )
                                                                                        }
                                                                                    </span>
                                                                                    <span
                                                                                        className={
                                                                                            nodeItem.url
                                                                                                ? "title-tip title-tip-up sideMnu childName"
                                                                                                : "title-tip title-tip-up sideMnu childName cursor-diabled"
                                                                                        }
                                                                                        onMouseEnter={e => {
                                                                                            this.props.onItemLeave();
                                                                                        }}
                                                                                        onMouseLeave={this.props.onItemLeave}
                                                                                        onClick={
                                                                                            nodeItem.url
                                                                                                ? async () => {
                                                                                                      this.props.onClickItem(
                                                                                                          nodeItem,
                                                                                                          2,
                                                                                                          () => {
                                                                                                              this.setState({
                                                                                                                  activeSubNode2: nodeItem.key
                                                                                                              });
                                                                                                              this.setState({
                                                                                                                  activeSubNode1: ""
                                                                                                              });
                                                                                                              this.setState({
                                                                                                                  activeSubNode3: "",
                                                                                                                  activeSubNode4: "",
                                                                                                                  activeSubNode5: ""
                                                                                                              });

                                                                                                              this.setActiveNode(
                                                                                                                  nodeItem.key,
                                                                                                                  item.key,
                                                                                                                  item
                                                                                                              );
                                                                                                          },
                                                                                                          node
                                                                                                      );
                                                                                                      this.handleSearchResultSelection({
                                                                                                          item,
                                                                                                          node,
                                                                                                          nodeItem
                                                                                                      });
                                                                                                  }
                                                                                                : null
                                                                                        }
                                                                                        title={nodeItem.entity}
                                                                                        data-multiline={true}
                                                                                        data-place="top"
                                                                                        data-effect="solid"
                                                                                        data-background-color="#007bff"
                                                                                        delay-update="1000"
                                                                                    >
                                                                                        {/* {nodeItem && nodeItem.entity ? <ReactTooltip /> : null} */}
                                                                                        {nodeItem && this.highlightMatch(nodeItem.label)}
                                                                                    </span>
                                                                                </div>
                                                                                {(nodeItem &&
                                                                                    nodeItem.nodes &&
                                                                                    nodeItem.nodes.length > 0 &&
                                                                                    nodeItem.nodes.map(child => {
                                                                                        return (
                                                                                            <>
                                                                                                {this.state.childNode.includes(
                                                                                                    nodeItem.key + item.label
                                                                                                ) ? (
                                                                                                    <>
                                                                                                        <div
                                                                                                            className={`${
                                                                                                                this.state.activeNode == child.key &&
                                                                                                                this.state.mainElement === item.key
                                                                                                                    ? "activeStyle1"
                                                                                                                    : ""
                                                                                                            }
                                                                                                                         ${
                                                                                                                             this.state.activeStyle[
                                                                                                                                 this.state
                                                                                                                                     .activeStyle
                                                                                                                                     .length - 1
                                                                                                                             ] == nodeItem.key &&
                                                                                                                             this.state.activeUrl ===
                                                                                                                                 item.key
                                                                                                                                 ? " childmain2 activeStyle"
                                                                                                                                 : "childmain2"
                                                                                                                         }`}
                                                                                                        >
                                                                                                            <span className="childspan"></span>
                                                                                                            <span>
                                                                                                                {
                                                                                                                    // child &&
                                                                                                                    // (!child.nodes ||
                                                                                                                    //     !child.nodes
                                                                                                                    //         .length)
                                                                                                                    !child.has_child ? (
                                                                                                                        <Icon
                                                                                                                            name="circle"
                                                                                                                            // color="grey"
                                                                                                                            color={
                                                                                                                                this.state
                                                                                                                                    .activeSubNode3 ==
                                                                                                                                child.key
                                                                                                                                    ? "blue"
                                                                                                                                    : "grey"
                                                                                                                            }
                                                                                                                            size="mini"
                                                                                                                        />
                                                                                                                    ) : (
                                                                                                                        <Icon
                                                                                                                            name={
                                                                                                                                this.state.buildingNode.includes(
                                                                                                                                    child.key +
                                                                                                                                        item.label
                                                                                                                                )
                                                                                                                                    ? "minus square"
                                                                                                                                    : "plus square"
                                                                                                                            }
                                                                                                                            color="grey"
                                                                                                                            onClick={async () => {
                                                                                                                                const flag2 =
                                                                                                                                    this.state.activeStyleTemp.some(
                                                                                                                                        i =>
                                                                                                                                            i.key ===
                                                                                                                                                child.key &&
                                                                                                                                            i.item.toLowerCase() ===
                                                                                                                                                item.key.toLowerCase()
                                                                                                                                    );
                                                                                                                                if (
                                                                                                                                    this.state.buildingNode.includes(
                                                                                                                                        child.key +
                                                                                                                                            item.label
                                                                                                                                    )
                                                                                                                                ) {
                                                                                                                                    this.resetNestedAccordionState(
                                                                                                                                        child,
                                                                                                                                        item,
                                                                                                                                        3
                                                                                                                                    );
                                                                                                                                } else {
                                                                                                                                    this.props.sideMenuHandler(
                                                                                                                                        this.findEntityNameForGGrandChild(
                                                                                                                                            item.name
                                                                                                                                        ),
                                                                                                                                        child,
                                                                                                                                        node.key,
                                                                                                                                        nodeItem.key,
                                                                                                                                        child.key
                                                                                                                                    );
                                                                                                                                    this.setState({
                                                                                                                                        ...this.state,
                                                                                                                                        buildingNode:
                                                                                                                                            [
                                                                                                                                                ...this
                                                                                                                                                    .state
                                                                                                                                                    .buildingNode,
                                                                                                                                                child.key +
                                                                                                                                                    item.label
                                                                                                                                            ],
                                                                                                                                        buildingNodeCollapse:
                                                                                                                                            [
                                                                                                                                                ...this
                                                                                                                                                    .state
                                                                                                                                                    .buildingNodeCollapse,
                                                                                                                                                {
                                                                                                                                                    item: item.url,
                                                                                                                                                    key:
                                                                                                                                                        child.key +
                                                                                                                                                        item.label
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                    });
                                                                                                                                }

                                                                                                                                if (flag2) {
                                                                                                                                    this.removeItem(
                                                                                                                                        child.key,
                                                                                                                                        item.key,
                                                                                                                                        child.entity,
                                                                                                                                        nodeItem.key
                                                                                                                                    );
                                                                                                                                } else {
                                                                                                                                    await this.setActiveStyle(
                                                                                                                                        child.key,
                                                                                                                                        item.key,
                                                                                                                                        child.entity,
                                                                                                                                        nodeItem.key
                                                                                                                                    );
                                                                                                                                }
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    )
                                                                                                                }
                                                                                                            </span>
                                                                                                            <span
                                                                                                                className={
                                                                                                                    child.url
                                                                                                                        ? "title-tip title-tip-up sideMnu childName"
                                                                                                                        : "title-tip title-tip-up sideMnu childName cursor-diabled"
                                                                                                                }
                                                                                                                onClick={
                                                                                                                    child.url
                                                                                                                        ? async e => {
                                                                                                                              this.props.onClickItem(
                                                                                                                                  child,
                                                                                                                                  3,
                                                                                                                                  () => {
                                                                                                                                      this.setState({
                                                                                                                                          activeSubNode3:
                                                                                                                                              child.key
                                                                                                                                      });
                                                                                                                                      this.setState({
                                                                                                                                          activeSubNode1:
                                                                                                                                              ""
                                                                                                                                      });
                                                                                                                                      this.setState({
                                                                                                                                          activeSubNode2:
                                                                                                                                              "",
                                                                                                                                          activeSubNode4:
                                                                                                                                              "",
                                                                                                                                          activeSubNode5:
                                                                                                                                              ""
                                                                                                                                      });

                                                                                                                                      this.setActiveNode(
                                                                                                                                          child.key,
                                                                                                                                          item.key,
                                                                                                                                          item
                                                                                                                                      );
                                                                                                                                  },
                                                                                                                                  node
                                                                                                                              );
                                                                                                                              this.handleSearchResultSelection(
                                                                                                                                  {
                                                                                                                                      item,
                                                                                                                                      node,
                                                                                                                                      nodeItem,
                                                                                                                                      child
                                                                                                                                  }
                                                                                                                              );
                                                                                                                          }
                                                                                                                        : null
                                                                                                                }
                                                                                                                title={child.entity}
                                                                                                                data-multiline={true}
                                                                                                                data-place="top"
                                                                                                                data-effect="solid"
                                                                                                                data-background-color="#007bff"
                                                                                                                delay-update="1000"
                                                                                                            >
                                                                                                                {/* {child && child.entity ? <ReactTooltip /> : null} */}
                                                                                                                {child &&
                                                                                                                    this.highlightMatch(child.label)}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                                {(child &&
                                                                                                    child.nodes &&
                                                                                                    child.nodes.length > 0 &&
                                                                                                    child.nodes.map(building => {
                                                                                                        return (
                                                                                                            <>
                                                                                                                {this.state.buildingNode.includes(
                                                                                                                    child.key + item.label
                                                                                                                ) ? (
                                                                                                                    <>
                                                                                                                        <div
                                                                                                                            className={`${
                                                                                                                                this.state
                                                                                                                                    .activeNode ==
                                                                                                                                    building.key &&
                                                                                                                                this.state
                                                                                                                                    .mainElement ===
                                                                                                                                    item.key
                                                                                                                                    ? "activeStyle1"
                                                                                                                                    : ""
                                                                                                                            }
                                                                                                                                         ${
                                                                                                                                             this
                                                                                                                                                 .state
                                                                                                                                                 .activeStyle[
                                                                                                                                                 this
                                                                                                                                                     .state
                                                                                                                                                     .activeStyle
                                                                                                                                                     .length -
                                                                                                                                                     1
                                                                                                                                             ] ==
                                                                                                                                                 child.key &&
                                                                                                                                             this
                                                                                                                                                 .state
                                                                                                                                                 .activeUrl ===
                                                                                                                                                 item.key
                                                                                                                                                 ? " childmain3 activeStyle"
                                                                                                                                                 : "childmain3"
                                                                                                                                         }`}
                                                                                                                        >
                                                                                                                            <span className="childspan1"></span>
                                                                                                                            <span>
                                                                                                                                {
                                                                                                                                    // building &&
                                                                                                                                    // (!building.nodes ||
                                                                                                                                    //     !building
                                                                                                                                    //         .nodes
                                                                                                                                    //         .length) ?
                                                                                                                                    !building.has_child ? (
                                                                                                                                        <Icon
                                                                                                                                            name="circle"
                                                                                                                                            // color="grey"
                                                                                                                                            color={
                                                                                                                                                this
                                                                                                                                                    .state
                                                                                                                                                    .activeSubNode4 ==
                                                                                                                                                building.key
                                                                                                                                                    ? "blue"
                                                                                                                                                    : "grey"
                                                                                                                                            }
                                                                                                                                            size="mini"
                                                                                                                                        />
                                                                                                                                    ) : (
                                                                                                                                        <Icon
                                                                                                                                            name={
                                                                                                                                                this.state.flooorNode.includes(
                                                                                                                                                    building.key +
                                                                                                                                                        item.label
                                                                                                                                                )
                                                                                                                                                    ? "minus square"
                                                                                                                                                    : "plus square"
                                                                                                                                            }
                                                                                                                                            color="grey"
                                                                                                                                            onClick={async () => {
                                                                                                                                                if (
                                                                                                                                                    this.state.flooorNode.includes(
                                                                                                                                                        building.key +
                                                                                                                                                            item.label
                                                                                                                                                    )
                                                                                                                                                ) {
                                                                                                                                                    this.resetNestedAccordionState(
                                                                                                                                                        building,
                                                                                                                                                        item,
                                                                                                                                                        4
                                                                                                                                                    );
                                                                                                                                                } else {
                                                                                                                                                    this.props.sideMenuHandler(
                                                                                                                                                        this.findEntityNameForFloors(
                                                                                                                                                            item.name
                                                                                                                                                        ),
                                                                                                                                                        building,
                                                                                                                                                        node.key,
                                                                                                                                                        nodeItem.key,
                                                                                                                                                        child.key,
                                                                                                                                                        building.key
                                                                                                                                                    );
                                                                                                                                                    this.setState(
                                                                                                                                                        {
                                                                                                                                                            ...this
                                                                                                                                                                .state,
                                                                                                                                                            flooorNode:
                                                                                                                                                                [
                                                                                                                                                                    ...this
                                                                                                                                                                        .state
                                                                                                                                                                        .flooorNode,
                                                                                                                                                                    building.key +
                                                                                                                                                                        item.label
                                                                                                                                                                ],
                                                                                                                                                            floorNodeCollapse:
                                                                                                                                                                [
                                                                                                                                                                    ...this
                                                                                                                                                                        .state
                                                                                                                                                                        .floorNodeCollapse,
                                                                                                                                                                    {
                                                                                                                                                                        item: item.url,
                                                                                                                                                                        key:
                                                                                                                                                                            building.key +
                                                                                                                                                                            item.label
                                                                                                                                                                    }
                                                                                                                                                                ]
                                                                                                                                                        }
                                                                                                                                                    );
                                                                                                                                                }

                                                                                                                                                if (
                                                                                                                                                    this.state.activeStyle.includes(
                                                                                                                                                        building.key
                                                                                                                                                    )
                                                                                                                                                ) {
                                                                                                                                                    this.removeItem(
                                                                                                                                                        building.key,
                                                                                                                                                        item.key,
                                                                                                                                                        building.entity,
                                                                                                                                                        child.key
                                                                                                                                                    );
                                                                                                                                                } else {
                                                                                                                                                    await this.setActiveStyle(
                                                                                                                                                        building.key,
                                                                                                                                                        item.key,
                                                                                                                                                        building.entity,
                                                                                                                                                        child.key
                                                                                                                                                    );
                                                                                                                                                }
                                                                                                                                            }}
                                                                                                                                        />
                                                                                                                                    )
                                                                                                                                }
                                                                                                                            </span>
                                                                                                                            <span
                                                                                                                                // key={
                                                                                                                                //     building.key +
                                                                                                                                //     item.label
                                                                                                                                // }
                                                                                                                                id={
                                                                                                                                    building.key +
                                                                                                                                    item.label
                                                                                                                                }
                                                                                                                                className="title-tip title-tip-up sideMnu childName"
                                                                                                                                onClick={async () => {
                                                                                                                                    this.props.onClickItem(
                                                                                                                                        building,
                                                                                                                                        4,
                                                                                                                                        () => {
                                                                                                                                            this.setState(
                                                                                                                                                {
                                                                                                                                                    activeSubNode4:
                                                                                                                                                        building.key
                                                                                                                                                }
                                                                                                                                            );
                                                                                                                                            this.setState(
                                                                                                                                                {
                                                                                                                                                    activeSubNode1:
                                                                                                                                                        ""
                                                                                                                                                }
                                                                                                                                            );
                                                                                                                                            this.setState(
                                                                                                                                                {
                                                                                                                                                    activeSubNode3:
                                                                                                                                                        ""
                                                                                                                                                }
                                                                                                                                            );
                                                                                                                                            this.setState(
                                                                                                                                                {
                                                                                                                                                    activeSubNode2:
                                                                                                                                                        "",
                                                                                                                                                    activeSubNode5:
                                                                                                                                                        ""
                                                                                                                                                }
                                                                                                                                            );

                                                                                                                                            this.setActiveNode(
                                                                                                                                                building.key,
                                                                                                                                                item.key,
                                                                                                                                                item
                                                                                                                                            );
                                                                                                                                        },
                                                                                                                                        node
                                                                                                                                    );
                                                                                                                                    this.handleSearchResultSelection(
                                                                                                                                        {
                                                                                                                                            item,
                                                                                                                                            node,
                                                                                                                                            nodeItem,
                                                                                                                                            child,
                                                                                                                                            building
                                                                                                                                        }
                                                                                                                                    );
                                                                                                                                }}
                                                                                                                                title={
                                                                                                                                    building.entity
                                                                                                                                }
                                                                                                                                data-multiline={true}
                                                                                                                                data-place="top"
                                                                                                                                data-effect="solid"
                                                                                                                                data-background-color="#007bff"
                                                                                                                                delay-update="1000"
                                                                                                                            >
                                                                                                                                {/* {building && building.entity ? <ReactTooltip /> : null} */}
                                                                                                                                {building &&
                                                                                                                                    this.highlightMatch(
                                                                                                                                        building.label
                                                                                                                                    )}
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    ""
                                                                                                                )}
                                                                                                                {(building &&
                                                                                                                    building.nodes &&
                                                                                                                    building.nodes.length > 0 &&
                                                                                                                    building.nodes.map(floor => {
                                                                                                                        return (
                                                                                                                            <>
                                                                                                                                {this.state.flooorNode.includes(
                                                                                                                                    building.key +
                                                                                                                                        item.label
                                                                                                                                ) ? (
                                                                                                                                    <>
                                                                                                                                        <div
                                                                                                                                            className={`${
                                                                                                                                                this
                                                                                                                                                    .state
                                                                                                                                                    .activeNode ==
                                                                                                                                                    floor.key &&
                                                                                                                                                this
                                                                                                                                                    .state
                                                                                                                                                    .mainElement ===
                                                                                                                                                    item.key
                                                                                                                                                    ? "activeStyle1"
                                                                                                                                                    : ""
                                                                                                                                            }
                                                                                                                                                             ${
                                                                                                                                                                 this
                                                                                                                                                                     .state
                                                                                                                                                                     .activeStyle[
                                                                                                                                                                     this
                                                                                                                                                                         .state
                                                                                                                                                                         .activeStyle
                                                                                                                                                                         .length -
                                                                                                                                                                         1
                                                                                                                                                                 ] ==
                                                                                                                                                                     building.key &&
                                                                                                                                                                 this
                                                                                                                                                                     .state
                                                                                                                                                                     .activeUrl ===
                                                                                                                                                                     item.key
                                                                                                                                                                     ? " childmain4 activeStyle"
                                                                                                                                                                     : "childmain4"
                                                                                                                                                             }`}
                                                                                                                                        >
                                                                                                                                            <span className="childspan2"></span>
                                                                                                                                            <span>
                                                                                                                                                {floor &&
                                                                                                                                                (!floor.nodes ||
                                                                                                                                                    !floor
                                                                                                                                                        .nodes
                                                                                                                                                        .length) ? (
                                                                                                                                                    <Icon
                                                                                                                                                        name="circle"
                                                                                                                                                        // color="grey"
                                                                                                                                                        color={
                                                                                                                                                            this
                                                                                                                                                                .state
                                                                                                                                                                .activeSubNode5 ==
                                                                                                                                                            floor.key
                                                                                                                                                                ? "blue"
                                                                                                                                                                : "grey"
                                                                                                                                                        }
                                                                                                                                                        size="mini"
                                                                                                                                                    />
                                                                                                                                                ) : (
                                                                                                                                                    <Icon
                                                                                                                                                        name={
                                                                                                                                                            this.state.lastNode.includes(
                                                                                                                                                                floor.key
                                                                                                                                                            )
                                                                                                                                                                ? "minus square"
                                                                                                                                                                : "plus square"
                                                                                                                                                        }
                                                                                                                                                        color="grey"
                                                                                                                                                        onClick={() => {
                                                                                                                                                            if (
                                                                                                                                                                this.state.lastNode.includes(
                                                                                                                                                                    floor.key
                                                                                                                                                                )
                                                                                                                                                            ) {
                                                                                                                                                                this.setState(
                                                                                                                                                                    {
                                                                                                                                                                        ...this
                                                                                                                                                                            .state,
                                                                                                                                                                        lastNode:
                                                                                                                                                                            this.state.lastNode.filter(
                                                                                                                                                                                itm =>
                                                                                                                                                                                    itm !==
                                                                                                                                                                                    floor.key
                                                                                                                                                                            )
                                                                                                                                                                    }
                                                                                                                                                                );
                                                                                                                                                            } else {
                                                                                                                                                                this.setState(
                                                                                                                                                                    {
                                                                                                                                                                        ...this
                                                                                                                                                                            .state,
                                                                                                                                                                        lastNode:
                                                                                                                                                                            [
                                                                                                                                                                                ...this
                                                                                                                                                                                    .state
                                                                                                                                                                                    .lastNode,
                                                                                                                                                                                floor.key
                                                                                                                                                                            ],
                                                                                                                                                                        floorNodeCollapse:
                                                                                                                                                                            [
                                                                                                                                                                                ...this
                                                                                                                                                                                    .state
                                                                                                                                                                                    .floorNodeCollapse,
                                                                                                                                                                                {
                                                                                                                                                                                    item: item.url,
                                                                                                                                                                                    key: floor.key
                                                                                                                                                                                }
                                                                                                                                                                            ]
                                                                                                                                                                    }
                                                                                                                                                                );
                                                                                                                                                            }
                                                                                                                                                        }}
                                                                                                                                                    />
                                                                                                                                                )}
                                                                                                                                            </span>
                                                                                                                                            <span
                                                                                                                                                className="title-tip title-tip-up sideMnu childName"
                                                                                                                                                onClick={async () => {
                                                                                                                                                    this.props.onClickItem(
                                                                                                                                                        floor,
                                                                                                                                                        5,
                                                                                                                                                        () => {
                                                                                                                                                            this.setState(
                                                                                                                                                                {
                                                                                                                                                                    activeSubNode5:
                                                                                                                                                                        floor.key
                                                                                                                                                                }
                                                                                                                                                            );
                                                                                                                                                            this.setState(
                                                                                                                                                                {
                                                                                                                                                                    activeSubNode1:
                                                                                                                                                                        ""
                                                                                                                                                                }
                                                                                                                                                            );
                                                                                                                                                            this.setState(
                                                                                                                                                                {
                                                                                                                                                                    activeSubNode3:
                                                                                                                                                                        ""
                                                                                                                                                                }
                                                                                                                                                            );
                                                                                                                                                            this.setState(
                                                                                                                                                                {
                                                                                                                                                                    activeSubNode2:
                                                                                                                                                                        "",
                                                                                                                                                                    activeSubNode4:
                                                                                                                                                                        ""
                                                                                                                                                                }
                                                                                                                                                            );

                                                                                                                                                            this.setActiveNode(
                                                                                                                                                                floor.key,
                                                                                                                                                                item.key,
                                                                                                                                                                item
                                                                                                                                                            );
                                                                                                                                                        },
                                                                                                                                                        node
                                                                                                                                                    );
                                                                                                                                                    this.handleSearchResultSelection(
                                                                                                                                                        {
                                                                                                                                                            item,
                                                                                                                                                            node,
                                                                                                                                                            nodeItem,
                                                                                                                                                            child,
                                                                                                                                                            building,
                                                                                                                                                            floor
                                                                                                                                                        }
                                                                                                                                                    );
                                                                                                                                                }}
                                                                                                                                                title={
                                                                                                                                                    floor.entity
                                                                                                                                                }
                                                                                                                                                data-multiline={
                                                                                                                                                    true
                                                                                                                                                }
                                                                                                                                                data-place="top"
                                                                                                                                                data-effect="solid"
                                                                                                                                                data-background-color="#007bff"
                                                                                                                                                delay-update="1000"
                                                                                                                                            >
                                                                                                                                                {/* {floor && floor.entity ? <ReactTooltip /> : null} */}
                                                                                                                                                {floor &&
                                                                                                                                                    this.highlightMatch(
                                                                                                                                                        floor.label
                                                                                                                                                    )}
                                                                                                                                            </span>
                                                                                                                                        </div>
                                                                                                                                    </>
                                                                                                                                ) : (
                                                                                                                                    ""
                                                                                                                                )}
                                                                                                                            </>
                                                                                                                        );
                                                                                                                    })) ||
                                                                                                                    (building &&
                                                                                                                    building.nodes &&
                                                                                                                    building.nodes.length == 0 &&
                                                                                                                    this.state.flooorNode.includes(
                                                                                                                        building.key + item.label
                                                                                                                    ) ? (
                                                                                                                        <div className="childmain4">
                                                                                                                            <span className="childspan2"></span>
                                                                                                                            <span className="title-tip title-tip-up sideMnu childName">
                                                                                                                                No Data
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                    ) : null)}
                                                                                                            </>
                                                                                                        );
                                                                                                    })) ||
                                                                                                    (child &&
                                                                                                    child.nodes &&
                                                                                                    child.nodes.length == 0 &&
                                                                                                    this.state.buildingNode.includes(
                                                                                                        child.key + item.label
                                                                                                    ) ? (
                                                                                                        <div className="childmain3">
                                                                                                            <span className="childspan1"></span>
                                                                                                            <span className="title-tip title-tip-up sideMnu childName cursor-diabled">
                                                                                                                No Data
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    ) : null)}
                                                                                            </>
                                                                                        );
                                                                                    })) ||
                                                                                    (nodeItem &&
                                                                                    nodeItem.nodes &&
                                                                                    nodeItem.nodes.length == 0 &&
                                                                                    this.state.childNode.includes(nodeItem.key + item.label) ? (
                                                                                        <div className="childmain2">
                                                                                            <span className="childspan"></span>
                                                                                            <span className="title-tip title-tip-up sideMnu childName cursor-diabled">
                                                                                                No Data
                                                                                            </span>
                                                                                        </div>
                                                                                    ) : null)}
                                                                            </>
                                                                        );
                                                                    })) ||
                                                                    (node &&
                                                                    node.nodes &&
                                                                    node.nodes.length == 0 &&
                                                                    this.state.subNode.includes(node.key + item.label) ? (
                                                                        <div className="childmain1">
                                                                            <span className="child1"></span>
                                                                            <span className="title-tip title-tip-up sideMnu childName cursor-diabled">
                                                                                No Data
                                                                            </span>
                                                                        </div>
                                                                    ) : null)}
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </React.Fragment>
                                        )
                                    );
                                })}
                        </>
                    ) : (
                        ""
                    )}
                </div>
            </React.Fragment>
        ) : null;
    };

    renderSidebarSearchControl = () => {
        const { sidebarSearchQuery, sidebarSearchInputRef, onSidebarSearchChange } = this.props;

        return (
            <div className="side-nav-search-slot ml-1 mr-1 expanded" onClick={e => e.stopPropagation()}>
                <input
                    ref={sidebarSearchInputRef}
                    type="search"
                    className="side-nav-search-input"
                    placeholder="Search..."
                    value={sidebarSearchQuery || ""}
                    onChange={onSidebarSearchChange}
                    onKeyDown={e => {
                        if (e?.key === "Escape") {
                            e.stopPropagation();
                        }
                    }}
                    onClick={e => {
                        e.stopPropagation();
                    }}
                    tabIndex={0}
                    aria-label="Search menu items"
                    autoComplete="off"
                    spellCheck={false}
                />
                <i className="fas fa-times cursor-pointer cls-close" role="button" tabIndex={0} onClick={() => this.props.onSidebarSearchClear?.()} />
            </div>
        );
    };
    render() {
        const data = this.props.data || [];
        const scrollItems = data.filter(d => d.view === true);
        const isSearching = Boolean(this.props.sidebarSearchQuery);
        const isSearchLoading = isSearching && this.props.sidebarSearchLoading;
        const scrollSearchEmpty = isSearching && scrollItems.length === 0;
        const virtualRows = isSearching && !isSearchLoading && !scrollSearchEmpty ? this.getVirtualMenuRows(scrollItems) : [];
        const virtualListKey = [
            this.props.sidebarSearchQuery,
            virtualRows.map((row, index) => this.getVirtualRowCacheKey(row, index)).join("-")
        ].join("-");
        if (this.virtualListKey !== virtualListKey) {
            this.virtualListKey = virtualListKey;
            this.virtualRowHeights = {};
            this.scheduleVirtualListReset();
        }
        this.virtualRows = virtualRows;

        return (
            <div className="side-nav-nav-root">
                <ReactTooltip
                    className="rc-tooltip-custom-class"
                    id="favoriteQuickLinkMenu"
                    place="bottom"
                    delayShow={1000}
                    effect="solid"
                    backgroundColor="#007bff"
                />
                <div className="side-nav-pinned">{this.renderSidebarSearchControl()}</div>
                <div className={`side-nav-menu-scroll ${isSearching ? "pr-0" : ""}`}>
                    {isSearching ? (
                        isSearchLoading ? (
                            <Loader />
                        ) : scrollSearchEmpty ? (
                            <div className="side-nav-search-empty" role="status">
                                No Data Found
                            </div>
                        ) : (
                            <AutoSizer>
                                {({ height, width }) => {
                                    if (this.virtualListWidth !== width) {
                                        this.virtualListWidth = width;
                                        this.virtualRowHeights = {};
                                        this.scheduleVirtualListReset();
                                    }

                                    return (
                                        <VirtualList
                                            ref={this.virtualListRef}
                                            height={height}
                                            width={width}
                                            itemCount={virtualRows.length}
                                            itemData={virtualRows}
                                            itemSize={this.getVirtualRowSize}
                                            overscanCount={8}
                                        >
                                            {this.renderVirtualMenuRow}
                                        </VirtualList>
                                    );
                                }}
                            </AutoSizer>
                        )
                    ) : (
                        scrollItems?.map((item, idx) => this.renderNavDataItem(item, idx))
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(SideNav);
